module.exports = __webpack_public_path__ + "img/SpecialistActive.323ef605.jpg";